import { jsx } from "react/jsx-runtime";
import { XAxisDomain } from "../internal/types.js";
import Select, { Option } from "../Select.js";
const XAxisFilter = ({ options, onChange, value }) => {
  return /* @__PURE__ */ jsx(
    Select,
    {
      label: "X-Axis",
      searchable: false,
      value,
      onSelect: (newValue) => onChange(newValue),
      children: Object.values(XAxisDomain).filter((opt) => options.includes(opt)).map((opt) => /* @__PURE__ */ jsx(Option, { value: opt, children: opt }, opt))
    }
  );
};
export {
  XAxisFilter as default
};
